(ns frontend.ui.component.lp-portal.report.overview.portfolio-at-fair-value.controller
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.chart.utils :as chart-utils]))

(defn portfolio-at-fair-value
  [chart-data-fair-value]
  (let [data (util/->array-of-tuples chart-data-fair-value :fair-value)]
    (donut-chart/donut-chart-config data
                                    {:data-label-formatter
                                     chart-utils/pie-me-label-formatter-no-division})))